var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLightbulb = function SvgLightbulb(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.75 10.5c.15-.75.525-1.275 1.125-1.875C13.625 7.95 14 6.975 14 6a4.5 4.5 0 1 0-9 0c0 .75.15 1.65 1.125 2.625C6.65 9.15 7.1 9.75 7.25 10.5M7.25 13.5h4.5M8 16.5h3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLightbulb);
export default ForwardRef;